// extracted by css-extract-rspack-plugin
export default {"inactive":"inactive--_vnin3jUEYAhouFd"};